import { Component, inject, Input, OnInit } from '@angular/core';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { TranslatePipe } from '@ngx-translate/core';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00045 } from '../../../../P00045';
import { P00032 } from '../../../../P00032';
import {
  convertTauxAccroissement,
  mVToVolt,
} from '../../../../../../helper/convertMeasure';
import convertSecondsToTime from '../../../../../../helper/convertSecondsToTime';
import { getTemperatureType } from '../../../../../../helper/temperature';

@Component({
  selector: 'app-p00032-sense-status',
  templateUrl: './p00032-sense-status.component.html',
  styleUrls: ['./p00032-sense-status.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    TranslatePipe,
    IonItem,
    IonLabel,
    IonList,
    CollapseComponent,
    DisplayRubriqueStatusWithWarningComponent,
  ],
})
export class P00032SenseStatusComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  get deviceTableData() {
    return (
      this.productClass?.getProductDeviceTableFromPool(
        this.edroNetworkManager.getPoolContext().pool!,
      ) ?? {}
    );
  }

  hasProductWarning() {
    const master = getPoolMasterClass(
      this.edroNetworkManager.getPoolContext().pool!,
    );
    return (
      master?.hasProduct(
        this.edroNetworkManager.getPoolContext().pool!,
        new P00032(),
      ) ?? 0
    );
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly mVToVolt = mVToVolt;
  protected readonly convertTauxAccroissement = convertTauxAccroissement;
  protected readonly convertSecondsToTime = convertSecondsToTime;
  protected readonly getTemperatureType = getTemperatureType;
}
